<template>
  <div
    v-if="localBookId"
    class="banner-container d-flex align-start justify-center"
    style="color: #ffffff;"
  >
    <div
      v-if="loading"
      class="d-flex flex-column flex-md-row flex-wrap align-center justify-center pt-10 px-md-12 pb-10 pb-md-5"
      style="gap: 40px"
    >
      <div class="d-flex flex-grow-1 flex-column flex-md-row align-center">
        <v-skeleton-loader
          class="mx-13 mb-10 mb-md-0"
          type="image"
          height="347"
          width="248"
        />
        <div
          class="mt-0 mt-md-16 flex-column justify-space-around"
          style="min-width: 248px"
        >
          <v-skeleton-loader
            type="heading"
            class="mb-6"
          />
          <v-skeleton-loader
            type="paragraph@3"
            width="100%"
          />
        </div>
      </div>
      <div class="d-flex flex-column align-center text-center">
        <div class="d-flex">
          <v-skeleton-loader
            v-for="index in 2"
            :key="index"
            class="ma-1"
            type="image"
            height="194"
            width="130"
          />
        </div>
        <div class="d-flex">
          <v-skeleton-loader
            v-for="index in 2"
            :key="index"
            class="ma-1"
            type="image"
            height="194"
            width="130"
          />
        </div>
      </div>
    </div>
    <div v-else-if="bannerBookIds.length === 3 && featuredBook">
      <div
        class="d-flex flex-column flex-md-row flex-md-nowrap align-center justify-center pt-10 px-md-12 pb-10 pb-md-10"
        style="gap: 20px"
      >
        <div class="d-flex flex-column flex-md-row align-center align-md-start banner-left-row">
          <div class="mb-10 mb-md-0 d-flex flex-column align-center align-md-start">
            <h1 class="text-h3 text-uppercase font-weight-black text-center text-md-left banner-heading pb-6">
              {{ $t("juneBanner.title") }}
            </h1>
            <img
              class="featured-cover mb-6"
              :src="require('@/assets/img/thumbnails/mwikali-and-the-forbidden-mask-cmpr.jpg')"
              :alt="$t('common.bookThumbnail')"
              @click="$router.push({ name: 'book', params: { id: featuredBook.id } })"
            >
          </div>
          <div class="mt-0 mt-md-16 px-8 px-md-0 d-flex flex-column flex-shrink-1 justify-space-around banner-details">
            <h2 class="text-h6 text-md-h5 font-weight-bold banner-book-title">
              {{ decodeHtml(featuredBook.title) }}
            </h2>
            <div
              v-if="featuredBook.bookAuthors && featuredBook.bookAuthors.length > 0"
              class="mb-4"
            >
              <h3 class="text-h6 text-md-h5 font-weight-regular">
                <span>
                  {{ $t("bookInfo.by") }}
                </span>
                <span
                  v-for="(item, index) in featuredBook.bookAuthors"
                  :key="index"
                >
                  {{
                    item.author.name + (index + 1 < featuredBook.bookAuthors.length ? ', ' : '')
                  }}
                </span>
              </h3>
            </div>
            <p
              class="text-body-1 font-weight-regular mb-9 banner-description"
              style="max-width: 560px; line-height: 1.5;"
              v-html="truncatedDescription"
            />
            <AddToCartButton
              :id="featuredBook.id"
              button-classes="text-h5 rounded-xxl"
              :simplified-id="featuredBook._id"
              :book="featuredBook"
              :height="$vuetify.breakpoint.smAndDown ? '56px' : '65px'"
              min-width="200px"
              :query-loading="false"
              show-cart
              color1="background"
              color2="background"
              text-color="primaryDark"
              icon-classes="text-h5 ml-2"
            />
          </div>
        </div>
        <div class="d-flex flex-column align-center text-center">
          <router-link
            class="explore-more-link text-h6 font-weight-regular pb-4"
            :to="{ name: 'browseBySubject', params: { code: 'best_sellers', name: $t('categories.bestSellers') } }"
          >
            {{ $t("juneBanner.exploreMore") }}
          </router-link>
          <div class="book-thumbnails pb-1">
            <div
              v-for="(book, index) in bookThumbnails"
              :key="index"
              class="book-thumbnail-container"
              @click="navigateToBook(book.path)"
            >
              <img
                :src="require(`@/assets/img/thumbnails/${book.thumbnail}.jpg`)"
                :class="'book-thumbnail' + (index === 1 ? ' center' : '')"
                :alt="$t('common.bookThumbnail')"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalBookQueries from "@/graphql/LocalBookQueries";
import { decodeHtml } from "@/helpers/generalFunctions";
import AddToCartButton from "@/views/checkout/AddToCartButton.vue";

export default {
  name: "JuneBanner",
  components: {
    AddToCartButton,
  },
  computed: {
    localBookId() {
      return process.env.VUE_APP_BANNER_BOOK_ID;
    },
    bannerBookIds() {
      const raw = process.env.VUE_APP_BANNER_BOOK_IDS || '';
      return raw ? raw.split(',') : [];
    },
    loading() {
      return this.$apollo.queries.featuredBook.loading;
    },
    featuredBookId() {
      return 6180;
    },
    relatedBookIds() {
      return [6140, 6128, 6180];
    },
    windowBaseUrl() {
      return window.location.origin;
    },
    affBookIds() {
      const raw = process.env.VUE_APP_BANNER_BOOK_IDS || '';
      return raw ? raw.split(',') : [];
    },
    bookThumbnails() {
      const ids = this.affBookIds;
      return [
        {
          thumbnail: "Odwar Vs the Shadow Queen",
          path: `${ids[0]}`
        },
        {
          thumbnail: "Soni and the life drinkers",
          path: `${ids[1]}`
        },
        {
          thumbnail: "mwikali-and-the-forbidden-mask-cmpr",
          path: `${ids[2]}`
        },
      ];
    },
    truncatedDescription() {
      const text = (this.featuredBook && this.featuredBook.description) || '';
      const MAX_CHARS = 355;
      const MAX_SENTENCES = 2;

      // Take first N sentences
      const sentences = text.match(/[^.!?]+[.!?]+\s*/g) || [text];
      let result = sentences.slice(0, MAX_SENTENCES).join('').trim();

      // If still too long, truncate at nearest word boundary
      if (result.length > MAX_CHARS) {
        result = result.slice(0, MAX_CHARS);
        const lastSpace = result.lastIndexOf(' ');
        result = (lastSpace > 0 ? result.slice(0, lastSpace) : result) + '...';
      } else if (result.length < text.length && !result.match(/[.!?]$/)) {
        result += '...';
      }

      // Italicize the book title within the description
      const title = (this.featuredBook && this.featuredBook.title) || '';
      // Use first two words of title to also match base title (e.g. "Rough Silk")
      const baseTitle = title.split(' ').slice(0, 2).join(' ');
      if (baseTitle) {
        const escaped = baseTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        result = result.replace(new RegExp(escaped, 'g'), `<em>${baseTitle}</em>`);
      }

      return result;
    },
  },
  methods: {
    decodeHtml,
    navigateToBook(path) {
      if (!path) return;
      this.$router.push({ name: 'book', params: { id: path } });
    },
  },
  apollo: {
    featuredBook: {
      query: LocalBookQueries.getLocalBook,
      variables() {
        return {
          id: this.localBookId,
        };
      },
      update: (data) => data.localBook,
      skip() {
        return !this.localBookId;
      },
    },
  },
};
</script>

<style lang="scss" scoped>

.text-h3 {
  font-size: 2.5rem !important
  }

.banner-container {
  position: relative;
  min-height: 500px;
  background: linear-gradient(to right, #7c6fd4, #5b4fc4, #3b2fa0);
  overflow: hidden;
  z-index: $z-base;
}

.featured-cover {
  width: 270px;
  height: auto;
  object-fit: contain;
  display: block;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  --hover-scale: 1;
  --hover-lift: 0px;
  transform: translateY(var(--hover-lift)) scale(var(--hover-scale));
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    --hover-scale: 1.05;
    --hover-lift: -8px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);
  }
}

.banner-book-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}

.banner-description {
  font-size: 1rem !important;
}

.banner-description em {
  font-style: italic;
}

.explore-more-link {
  color: #ffffff;
  text-decoration: none;
  display: block;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
    text-decoration: underline;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .banner-left-row {
    gap: 0;
  }

  .banner-details {
    margin-left: -100px;
  }

  .banner-heading {
    white-space: nowrap;
    text-align: left !important;
  }
}

.book-thumbnails {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  margin: 0;
  z-index: $z-base;
  min-width: 300px;
  position: relative;
}

.book-thumbnail-container {
  width: 155px;
  overflow: visible;
  display: block;
  margin: 0;
  padding: 0;
  z-index: 1;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  --hover-scale: 1;
  --hover-lift: 0px;
  transform: translateY(var(--hover-lift)) scale(var(--hover-scale));
  transition: transform 0.2s ease, z-index 0s;

  &:hover {
    --hover-scale: 1.05;
    --hover-lift: -8px;
    z-index: 10;
  }
}

.book-thumbnail-container:has(.book-thumbnail.center) {
  width: 210px;
  z-index: $z-top;
  margin: 0;
}

.book-thumbnail {
  width: 100%;
  height: auto;
  display: block;
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}

.book-thumbnail.center {
  width: 100%;
  height: auto;
  z-index: $z-top;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {

  .book-thumbnails {
    gap: 5px;
    min-width: 250px;
  }

  .book-thumbnail-container {
    width: 115px;
    margin: 0;
    overflow: visible;
  }

  .book-thumbnail-container:has(.book-thumbnail.center) {
    width: 155px;
    margin: 0;
  }

  .book-thumbnail {
    width: 100%;
    height: auto;
    display: block;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  }

  .book-thumbnail.center {
    width: 100%;
    height: 100%;
  }

  .text-h3 {
    font-size: 2.1rem !important
  }

  .featured-cover {
    width: 219px;
    height: auto;
    cursor: pointer;
  }

  .px-8 {
    padding-right: 85px !important;
    padding-left: 85px !important;
  }

}

</style>